import { tv } from "@pcln/horizon";
const searchFormTabs = tv({
    slots: {
        root: '@container w-auto',
        content: 'mx-auto flex max-w-7xl flex-col justify-center gap-4 py-4',
        listFrame: 'flex w-full justify-center px-3 pt-1 @min-3xl:px-0 @min-3xl:pt-0'
    }
});
export { searchFormTabs };
